import PropTypes from 'prop-types';
import React from 'react';
import { Animated, Easing } from 'react-native-web';

const DEF_EASING = Easing.bezier(.8, .2, .2, .8)

class FadeFromDown extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            animationTranslationProgress: new Animated.Value(0),
            animationOpacityProgress: new Animated.Value(0),
        }
    }

    componentDidMount() {
        if (this.props.visible)
            this.doAnimateToApear()
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.visible && nextProps.visible)
            this.doAnimateToApear()

        if (this.props.visible && !nextProps.visible)
            this.doAnimateToDisapear()
    }

    doAnimateToApear() {
        Animated.parallel([
            Animated.timing(this.state.animationTranslationProgress, {
                toValue: 1,
                easing: DEF_EASING,
                duration: this.props.duration,
                delay: this.props.delay
            }),
            Animated.timing(this.state.animationOpacityProgress, {
                toValue: 1,
                duration: this.props.duration,
                delay: this.props.delay
            })
        ]).start()
    }

    doAnimateToDisapear() {
        Animated.parallel([
            Animated.timing(this.state.animationTranslationProgress, {
                toValue: 0,
                easing: DEF_EASING,
                duration: this.props.duration / 2
            }),
            Animated.timing(this.state.animationOpacityProgress, {
                toValue: 0,
                duration: this.props.duration / 2
            })
        ]).start()
    }

    render() {

        const { style, ...props } = this.props

        return (
            <Animated.View {...props}
                style={{
                    opacity: this.state.animationOpacityProgress,
                    transform: [{
                        translateY: this.state.animationTranslationProgress.interpolate({
                            inputRange: [0, 1],
                            outputRange: [32, 0],
                        }),
                    }],
                    ...style,
                }} />
        )
    }

}

FadeFromDown.propTypes = {
    visible: PropTypes.bool,
    duration: PropTypes.number,
    delay: PropTypes.number
}

FadeFromDown.defaultProps = {
    visible: false,
    duration: 800,
    delay: 0
}

export default FadeFromDown


// WEBPACK FOOTER //
// ./src/components/transitions/FadeFromDown.js